export enum LoadLevel {
  Full = 'Full',
  Partial = 'Partial'
}
